"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseEnvelope = void 0;
const zod_1 = require("zod");
/**
 * traceId - Unique identifier for tracing the request. Can be an AWS request ID.
 */
exports.ResponseEnvelope = zod_1.z.discriminatedUnion('status', [
    zod_1.z.object({
        status: zod_1.z.literal('success'),
        traceId: zod_1.z.string().optional(),
        data: zod_1.z.unknown(),
    }),
    zod_1.z.object({
        status: zod_1.z.literal('error'),
        traceId: zod_1.z.string().optional(),
        error: zod_1.z.object({
            message: zod_1.z.string(),
            code: zod_1.z.string(),
        }),
    }),
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2UtZW52ZWxvcGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVzcG9uc2UtZW52ZWxvcGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXVCO0FBRXZCOztHQUVHO0FBQ1UsUUFBQSxnQkFBZ0IsR0FBRyxPQUFDLENBQUMsa0JBQWtCLENBQUMsUUFBUSxFQUFFO0lBQzdELE9BQUMsQ0FBQyxNQUFNLENBQUM7UUFDUCxNQUFNLEVBQUUsT0FBQyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUM7UUFDNUIsT0FBTyxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7UUFDOUIsSUFBSSxFQUFFLE9BQUMsQ0FBQyxPQUFPLEVBQUU7S0FDbEIsQ0FBQztJQUNGLE9BQUMsQ0FBQyxNQUFNLENBQUM7UUFDUCxNQUFNLEVBQUUsT0FBQyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUM7UUFDMUIsT0FBTyxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7UUFDOUIsS0FBSyxFQUFFLE9BQUMsQ0FBQyxNQUFNLENBQUM7WUFDZCxPQUFPLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtZQUNuQixJQUFJLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtTQUNqQixDQUFDO0tBQ0gsQ0FBQztDQUNILENBQUMsQ0FBQSJ9